// GENERATED by @platform/contracts from specs/billing/main.tsp. Do not edit; run `pnpm generate`.
/* eslint-disable */
import { createCaller } from '../../client/runtime.js';
import { operations } from './schemas.js';
export function createBillingClient(options) {
    const call = createCaller(options);
    return {
        /** List tenant subscriptions, optionally by status. */
        Subscriptions_list: (input = {}) => call(operations.Subscriptions_list, input),
        /** One tenant's subscription record. */
        Subscriptions_get: (input) => call(operations.Subscriptions_get, input),
        /** Adjust a tenant's subscription on Stripe: seat quantity, cancel at period end. Audited. */
        Subscriptions_adjust: (input) => call(operations.Subscriptions_adjust, input),
        /** Create (or resume) a hosted Stripe Checkout Session for the tenant's package. Returns the URL to redirect to. */
        Checkouts_create: (input) => call(operations.Checkouts_create, input),
        /** Open a Stripe Customer Portal session for the tenant (payment method, invoices, cancellation). */
        Portals_create: (input) => call(operations.Portals_create, input),
        /** The caller's tenant billing state: plan, seats, current period, next and last invoice, portal availability. */
        Summary_get: (input = {}) => call(operations.Summary_get, input),
        /**
         * Stripe webhook endpoint. Authenticated by `Stripe-Signature` over the raw body, idempotent
         * on `event.id`, tolerant of replays and out-of-order delivery. Returns 200 once the event is
         * recorded (or was already processed), 401 on a bad signature, 400 on an unparseable body.
         */
        Webhooks_receive: (input) => call(operations.Webhooks_receive, input),
    };
}
//# sourceMappingURL=client.js.map